import get from 'lodash/get';

export const createRouteParamSelector = propName => (state, props) => {
  return get(props, ['match', 'params', propName]) || get(props, [propName]);
};

export const idSelector = (state, props) => (props.id || '').toString();
